<ng-template #unavailableDoc>
    <div class="detail-item-missing cell" tooltipPosition="top" [pTooltip]="'REQUEST_DETAIL.NOT_AVAILABLE' | translate">
        <span class="material-symbols-outlined"> info </span>
    </div>
</ng-template>

@if (headerLabel()) {
    <h2>{{ headerLabelTranslated() }}</h2>
}

<div class="detail-content">
    <div class="detail-content-header">
        <span class="material-symbols-outlined custom-doc "> description </span>
        <h3>{{ contentLabelTranslated() }}</h3>
    </div>

    @for (doc of expectedDocs(); track doc) {
        <div class="detail-content-item">
            <p class="detail-item-name">{{ 'DOCUMENTS.' + doc | translate }}</p>

            @if (availableDocs().includes(doc)) {
                <div class="detail-item-links">
                    @if (showOpenPdfButton(doc)) {
                        <button pButton tooltipPosition="top" [pTooltip]="'REQUEST_DETAIL.OPEN_PDF' | translate" type="button" (click)="openPdf(doc)">
                            <span class="material-symbols-outlined"> visibility </span>
                            {{ 'REQUEST_DETAIL.PDF' | translate }}
                        </button>
                    } @else {
                        <ng-container *ngTemplateOutlet="unavailableDoc" />
                    }

                    @if (showJsonButtons(doc)) {
                        <button pButton tooltipPosition="top" [pTooltip]="'REQUEST_DETAIL.OPEN_JSON' | translate" type="button" (click)="openJson(doc)">
                            <span class="material-symbols-outlined"> visibility </span>
                            {{ 'REQUEST_DETAIL.JSON' | translate }}
                        </button>

                        <button pButton tooltipPosition="top" [pTooltip]="'REQUEST_DETAIL.DOWNLOAD_JSON' | translate" type="button" (click)="downloadJson(doc)">
                            <span class="material-symbols-outlined"> download </span>
                            {{ 'REQUEST_DETAIL.JSON' | translate }}
                        </button>
                    } @else {
                        <ng-container *ngTemplateOutlet="unavailableDoc" />
                        <ng-container *ngTemplateOutlet="unavailableDoc" />
                    }
                </div>
            }@else {
                <div class="detail-item-missing row">
                    @if (areDocumentsDownloaded()) {
                        {{ 'REQUEST_DETAIL.NOT_APPLICABLE' | translate }}
                    }@else {
                        {{ 'REQUEST_DETAIL.PENDING_DOWNLOAD' | translate }}
                    }
                </div>
            }
        </div>
    }
</div>
